<template>
  <BaseModal ref="modal">
    <UiModalDialog
     class="jps-image-select-modal"
     :no-closer="!_modalProps?.closeable"
     :dialog-width="$isMobile ? '100vw' : '80vw'"
     :dialog-height="$isMobile ? '100vh' : '90vh'"
    >
      <template #header>
        <BaseIcon name="mdi/image" />
        {{ ls({ ja: "画像", en: "Set Image" }) }}
      </template>
      <div class="jps-modal-content">
        <BaseTab
          :tab-options="tabOptions"
          v-model="index"
          styled="tab"
          class="image-select-modal-body"
          v-if="i"
        >
          <BaseTabPanel val="image-select-modal-tab-type" :show-cms="true">
            <div class="tab-content">
              <table class="jps-table">
                <tbody>
                  <tr>
                    <td>
                      <button
                        class="jps-button"
                        @click="selectType('ITEM')"
                        :disabled="i.imgType === 'ITEM'"
                      >
                        {{ lst(dapLangGlobal.imageSelect.material, ls(dapLangGlobal.serviceName)) }}
                      </button>
                    </td>
                    <td>
                      {{
                        lst(dapLangGlobal.imageSelect.thumbnail, ls(dapLangGlobal.serviceName))
                      }}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <button
                        @click="selectType('URL')"
                        :disabled="i.imgType === 'URL'"
                        class="jps-button"
                      >
                        {{ lss('URLを指定', 'URL') }}
                      </button>
                    </td>
                    <td>
                      {{
                        lss(
                          'インターネット上に公開されている画像のURLを指定します。',
                          'Enter a public image URL',
                        )
                      }}
                    </td>
                  </tr>
                  <tr v-if="isOrg">
                    <td>
                      <button
                        class="jps-button"
                        @click="selectType('UPLOAD')"
                        :disabled="i.imgType === 'UPLOAD'"
                      >
                        {{ lss('画像をアップロード', 'Upload') }}
                      </button>
                    </td>
                    <td>
                      {{
                        lst(dapLangGlobal.imageSelect.upload, ls(dapLangGlobal.serviceName))
                      }}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <button
                        class="jps-button"
                        @click="selectType('IIIF')"
                        :disabled="i.imgType === 'IIIF'"
                      >
                        {{ lss('IIIFから', 'From IIIF') }}
                      </button>
                    </td>
                    <td>
                      {{
                        lss(
                          'IIIFのマニフェストから設定します。',
                          'Set from an IIIF Manifest',
                        )
                      }}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <button
                        type="button"
                        class="jps-button"
                        @click="modal.resolve(null)"
                      >
                        {{ lss('未選択に戻す', 'Clear selection') }}
                      </button>
                    </td>
                    <td>
                      {{
                        lss(
                          '画像を未選択状態に戻します。',
                          'Remove the selected image',
                        )
                      }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </BaseTabPanel>
          <BaseTabPanel val="image-select-modal-tab-image" :show-cms="true">
            <!--種別毎のフィールド -->
            <div class="tab-content">
              <!-- アイテム -->
              <template v-if="i.imgType === 'ITEM'">
                <div class="jps-field">
                  <button
                    type="button"
                    class="jps-button button-margin"
                    @click="selectItem()"
                  >
                    <BaseIcon name="mdi/image" />
                    {{ lst(dapLangGlobal.imageSelect.metadata, ls(dapLangGlobal.serviceName)) }}
                  </button>
                  <UiDataPanel v-if="item" type="item" :data="item" :nolink="true" />
                  <p v-else class="jps-message jps-red">
                    {{ lss('資料を選んで下さい', 'Please select an item') }}
                  </p>
                </div>
                <div class="jps-field" v-if="item && item.common.iiifUrl">
                  <button
                    type="button"
                    class="jps-button button-margin"
                    @click="selectIIIF()"
                  >
                    {{ ls({ ja: "コマを選択", en: "Select Page" }) }}
                  </button>
                  <label class="jps-label is-size-7">{{
                    ls({ ja: "info.json URL", en: "info.json URL" })
                  }}</label>
                  <input
                    class="jps-input"
                    type="text"
                    disabled
                    v-model="i.infoJsonUrl"
                  />
                  <p v-if="!i.infoJsonUrl" class="jps-message jps-red">
                    コマを選んでください
                  </p>
                </div>
              </template>
              <!-- アップロード -->
              <div class="upload" v-if="i.imgType == 'UPLOAD'">
                <button type="button" class="jps-button" @click="newUpload()">
                  {{ lss('新規アップロード', 'Upload') }}
                </button>
                <button type="button" class="jps-button" @click="selectUpload()">
                  {{
                    lss(
                      'アップロード済みの画像から選ぶ',
                      'Select from uploaded images.',
                    )
                  }}
                </button>
                <ContentPanel
                  v-if="content"
                  :content="content"
                  :editable="true"
                />
                <p v-else class="alert">
                  {{ lss('画像を選んでください', 'Select image') }}
                </p>
                <ContentEditModal ref="contentEditModal" />
                <ContentSelectModal ref="contentSelectModal" />
              </div>
              <!-- IIIF -->
              <template v-if="i.imgType === 'IIIF'">
                <div class="jps-field">
                  <label class="jps-label-col">
                    {{ ls({ ja: "マニフェストURL", en: "[値はまだない]" }) }}
                    <input
                      class="jps-input"
                      type="text"
                      v-model="i.manifestUrl"
                    />
                  </label>
                </div>
                <div v-if="i.manifestUrl" class="image-select-modal-select">
                  <a class="jps-button image-select-modal-select-button" @click="selectIIIF()">
                    {{ ls({ ja: "コマを選択", en: "Select Page" }) }}
                  </a>
                  <div class="jps-field">
                    <label class="jps-label-col">
                      {{ ls({ ja: "info.json URL", en: "info.json URL" }) }}
                      <input
                        class="jps-input"
                        type="text"
                        disabled
                        v-model="i.infoJsonUrl"
                      />
                    </label>
                  </div>
                </div>
              </template>
              <ValidationForm
                v-if="i.imgType === 'URL' && rule"
                :rule="rule"
                :target="i"
                only="url,thumbnailUrl"
              />
              <UiItemSelectorModal ref="itemSelectorModal" />
              <IiifSelectModal ref="iiifSelectModal" />
            </div>
          </BaseTabPanel>
          <BaseTabPanel val="image-select-modal-tab-info" :show-cms="true">
            <ValidationForm
              class="tab-content"
              v-if="i.imgType != null && rule"
              :rule="rule"
              :target="i"
              except="url,thumbnailUrl,cover"
              @valid="(v) => valid = v"
            />
          </BaseTabPanel>
          <BaseTabPanel val="image-select-modal-tab-cut" :show-cms="true">
            <div class="tab-content">
              <button
                v-if="canCut"
                type="button"
                class="jps-button"
                @click="cutImage()"
              >
                {{ ls({ ja: "範囲を選択する", en: "Select Area" }) }}
              </button>
            </div>
            <ValidationForm
              class="tab-content"
              v-if="i.imgType != null && rule"
              :rule="rule"
              :target="i"
              only="cover"
            />
            <AreaSelectModal ref="areaSelectModal" />
          </BaseTabPanel>
        </BaseTab>
        <div class="jps-preview is-hidden-mobile">
          <h3>{{ lss('画像のプレビュー', 'Preview') }}</h3>
          <UiImageSelection :image="i" :w="previewWidth" :h="previewHeight" />
            <dl class="jps-meta">
              <dt>{{ lss('タイトル', 'Title') }}</dt>
              <dd>{{ ls(compi.title, '-') }}</dd>
              <dt>{{ lss('解説', 'Description') }}</dt>
              <dd>{{ ls(compi.description, '-') }}</dd>
              <dt>{{ lss('出典', 'Source') }}</dt>
              <dd>
                <a v-if="compi.sourceUrl" :href="compi.sourceUrl" v-target="">{{
                  ls(compi.source, '-')
                }}</a>
                <span v-else>{{ ls(compi.source, '-') }}</span>
              </dd>
              <dt>{{ lss('権利区分', 'Rights') }}</dt>
              <dd>{{ lc(dataStore.code('jps-rights_type'), compi.contentsRightsType, '-') }}</dd>
              <dt>{{ lss('権利表示', 'Attribution') }}</dt>
              <dd>
                <p v-html="ls(compi.contentsRights, '-')"></p>
              </dd>
            </dl>
        </div>
      </div>
      <template #buttons>
        <button @click="modal.reject()">{{ ls(dapLangGlobal.cancel) }}</button>
        <button @click="confirm()" :disabled="!allValid">{{ ls(dapLangGlobal.save) }}</button>
      </template>
    </UiModalDialog>
  </BaseModal>
</template>

<script lang="ts" setup>
import vTarget from '~/directives/target'
import type { BaseModal, ContentEditModal, ContentSelectModal, UiItemSelectorModal, IiifSelectModal, AreaSelectModal } from '#components'
import { dapLangGlobal } from '#imports'
import type { TabOption } from '~/components/base/BaseTab.vue'
import type { ModalProps } from '~/components/base/BaseModal.vue'

const { ls, lss, lst, lc } = useI18n()
const { isOrg } = useUserStore()
const dataStore = useDataStore()
const { compImageSelection } = useImageSelection()
const { iiifImageUrlFromInfo, getInfoJson } = useIIIF()
const { iiifImageUrlFromContent } = useContent()
const { getSearchId } = useItem()
const { $isMobile } = useNuxtApp()

interface Props {
  image?: ImageSelection,
  ruleField?: ValidationRuleField,
  initItem?: Item
}
const props = withDefaults(defineProps<Props>(), {
})

const modal = ref<InstanceType<typeof BaseModal>>()
const _image: Ref<ImageSelection> = ref()
const _ruleField: Ref<ValidationRuleField> = ref()
const _initItem: Ref<Item> = ref()
const _modalProps: Ref<ModalProps> = ref()
const openAwait = async (options?: Props, modalProps?: ModalProps) => {
  i.value = null
  content.value = null
  index.value = 'image-select-modal-tab-type'
  valid.value = false
  previewWidth.value = 200

  setOptionsValue(_image, 'image', props, options)
  setOptionsValue(_ruleField, 'ruleField', props, options)
  setOptionsValue(_initItem, 'initItem', props, options)

  if (!isEmpty(_image.value)) {
    i.value = clone(_image.value)
    if (i.value.imgType === 'UPLOAD' && i.value.contentId) {
      content.value = dataStore.content(i.value.contentId)
    }
    index.value = 'image-select-modal-tab-info'
  } else {
    i.value = { imgType: null }
    if (_initItem.value) {
      i.value.imgType = 'ITEM'
      selectItemInner(_initItem.value)
      index.value = 'image-select-modal-tab-image'
    }
  }

  //サムネ検索用検索
  let cs = clone(systemCrossSearchCs())
  cs.searchFields = cs.searchFields.filter((sf) => sf.type !== 'image')
  itemss.value = useSearch(cs, getSearchId(systemCrossSearchId()), {
    configSyncRoute: false,
    queryRewriter: (q: SearchQuery) => {
      q.exists = ['common.thumbnailUrl']
      return q
    }
  })
  _modalProps.value = modalProps
  return await modal.value.openAwait<ImageSelection>(_modalProps.value)
}
defineExpose({ openAwait })

const copyFields = (fields: string[], mandatory: string[] = []): ValidationRule => {
  let rules: ValidationRule = {fields: {}}
  fields.forEach((field) => {
    rules.fields[field] = clone(IMAGE_SELECTION_RULE.fields[field])
    if (mandatory.includes(field)) {
      if (
        rules.fields[field].objRuleName &&
        rules.fields[field].objRuleName.startsWith('jps-lang_string')
      ) {
        rules.fields[field].jaMandatory = true
      } else {
        rules.fields[field].mandatory = true
      }
    }
  })
  return rules
}

//画像種別ごとの手動で設定するフィールド
const rules: { [key: string]: ValidationRule } = {}
rules['ITEM'] = copyFields([
  'title',
  'description',
  'source',
  'sourceUrl',
  'cover',
])
rules['URL'] = copyFields(
  [
    'url',
    'thumbnailUrl',
    'title',
    'description',
    'cover',
    'contentsRightsType',
    'contentsRights',
    'source',
    'sourceUrl',
  ],
  ['url', 'title', 'contentsRightsType', 'source']
)
rules['IIIF'] = copyFields(
  [
    'title',
    'description',
    'cover',
    'contentsRightsType',
    'contentsRights',
    'source',
    'sourceUrl',
  ],
  ['title', 'contentsRightsType', 'source']
)
rules['UPLOAD'] = copyFields(['title', 'description', 'cover'])

//画像種別ごとの有効なフィールド
const validFields: { [key: string]: string[] } = {}
validFields['ITEM'] = [
  'imgType',
  'itemId',
  'itemIndex',
  'infoJsonUrl',
  'x',
  'y',
  'w',
  'h',
  'title',
  'description',
  'cover',
]
validFields['UPLOAD'] = [
  'imgType',
  'contentId',
  'imageId',
  'x',
  'y',
  'w',
  'h',
  'title',
  'description',
  'cover',
]
validFields['IIIF'] = [
  'manifestUrl',
  'infoJsonUrl',
  'x',
  'y',
  'w',
  'h',
  'title',
  'description',
  'contentsRightsType',
  'contentsRights',
  'source',
  'sourceUrl',
  'cover',
]
validFields['URL'] = [
  'url',
  'thumbnailUrl',
  'x',
  'y',
  'w',
  'h',
  'title',
  'description',
  'contentsRightsType',
  'contentsRights',
  'source',
  'sourceUrl',
  'cover',
]

const index: Ref<string> = ref('image-select-modal-tab-type')
const tabOptions = computed((): TabOption[] => {
  return [
    {
      val: 'image-select-modal-tab-type',
      label: ls({ ja: '画像の指定方法を選択', en: 'Select Image Source' }),
    },
    {
      val: 'image-select-modal-tab-image',
      label: ls({ ja: '画像を指定', en: 'Select Image' }),
      disabled: i.value.imgType == null,
      alert: !imgValid.value,
    },
    {
      val: 'image-select-modal-tab-info',
      label: ls({ ja: '画像にタイトルや説明をつける', en: 'Add Image Info' }),
      disabled: i.value.imgType == null,
      alert: !valid.value,
    },
    {
      val: 'image-select-modal-tab-cut',
      label: ls({ ja: '画像を切り抜く', en: 'Crop Image' }),
      disabled: i.value.imgType == null || !imgValid.value,
    },
  ]
})

const i: Ref<ImageSelection> = ref(null)
const content: Ref<Content> = ref(null)

const item = computed(() => {
  if (i.value.itemId) return dataStore.item(i.value.itemId)
  return null
})
const compi = computed(() => {
  return compImageSelection(i.value)
})

const itemss: Ref<SearchStore<Item>> = ref(null)
const valid: Ref<boolean> = ref(false)
const previewWidth = ref(200)
const previewHeight = computed(() => {
  if (_ruleField.value && _ruleField.value.imageRatio) {
    let [x, y] = _ruleField.value.imageRatio.split(':').map((v) => Number(v))
    return Math.floor((previewWidth.value / x) * y)
  }
  return previewWidth.value
})

const selectType = (type: ImageSelectionType) => {
  let tmp = { imgType: type }
  Object.keys(rules[type].fields).forEach((k) => {
    let rule = rules[type].fields[k]
    if (rule.objRuleName) {
      tmp[k] = {}
    } else {
      tmp[k] = null
    }
  })
  i.value = tmp
  index.value = 'image-select-modal-tab-image'
}

const rule = computed(() => {
  return rules[i.value.imgType]
})

const imgValid = computed(() => {
  if (!i.value.imgType) return false
  switch (i.value.imgType) {
    case 'ITEM':
      if (!item.value) return false
      if (item.value.common.iiifUrl) {
        if (i.value.infoJsonUrl) {
          return true
        } else {
          return false
        }
      }
      if (!item.value.common.contentsUrl && !item.value.common.thumbnailUrl) {
        return false
      } else {
        return true
      }
    case 'UPLOAD':
      return i.value.contentId && i.value.imageId
    case 'IIIF':
      return i.value.manifestUrl && i.value.infoJsonUrl
    case 'URL':
      return i.value.url
  }
  return false
})

const allValid = computed(() => {
  return imgValid.value && valid.value
})

const confirm = () => {
  if (!allValid.value) return
  let newImage: ImageSelection = {}
  validFields[i.value.imgType].forEach((field) => {
    newImage[field] = i.value[field]
  })
  if (i.value.imgType === 'ITEM') {
    if (item.value.common.iiifUrl) {
      newImage.manifestUrl = item.value.common.iiifUrl
    } else {
      if (
        !isEmptyArray(item.value.common.contentsUrl) &&
        item.value.common.contentsType === 'image'
      ) {
        newImage.url = item.value.common.contentsUrl[i.value.itemIndex]
        newImage.thumbnailUrl = item.value.common.thumbnailUrl[i.value.itemIndex]
      } else {
        newImage.url = item.value.common.thumbnailUrl[i.value.itemIndex]
      }
    }
  }
  modal.value.resolve(i.value)
}

const itemSelectorModal = ref<InstanceType<typeof UiItemSelectorModal>>()
const selectItem = async () => {
  try {
    const item = await itemSelectorModal.value.openAwait({
      ss: itemss.value,
    }) as Item
    if (!item) return
    selectItemInner(item)
  } catch (cancel) {}
}

const selectItemInner = (_item: Item) => {
  dataStore.put('item', _item.id, _item)
  i.value.itemId = _item.id
  i.value.manifestUrl = null
  i.value.infoJsonUrl = null
  i.value.url = null
  i.value.thumbnailUrl = null
  if (_item.common.iiifUrl) {
    i.value.manifestUrl = _item.common.iiifUrl
    i.value.infoJsonUrl = null
  } else {
    //TODO 複数サムネイルの場合の選択 改修前から存在したTODO
    i.value.itemIndex = '0'
    if (!isEmptyArray(item.value.common.contentsUrl)) {
      i.value.url = item.value.common.contentsUrl[0]
      if (!isEmptyArray(_item.common.thumbnailUrl)) {
        i.value.thumbnailUrl = item.value.common.thumbnailUrl[0]
      }
    } else if (!isEmptyArray(_item.common.thumbnailUrl)) {
      i.value.url = item.value.common.thumbnailUrl[0]
    }
  }
}

const iiifSelectModal = ref<InstanceType<typeof IiifSelectModal>>()
const selectIIIF = async () => {
  try {
    const infoJsonUrl = await iiifSelectModal.value.openAwait({
      manifestUrl: i.value.manifestUrl
    })
    i.value.infoJsonUrl = infoJsonUrl
  } catch (error) {}
}

const contentEditModal = ref<InstanceType<typeof ContentEditModal>>()
const newUpload = async () => {
  try {
    let _content = await contentEditModal.value.openAwait({
      mode: 'new',
      single: true
    }) as Content
    if (!_content) return
    dataStore.put('content', _content.id, _content)
    i.value.contentId = _content.id
    i.value.imageId = _content.images[0].id
    content.value = _content
  } catch (e) {}
}

const contentSelectModal = ref<InstanceType<typeof ContentSelectModal>>()
const selectUpload = async () => {
  try {
    let { content: _content, image } = await contentSelectModal.value.openAwait()
    if (!_content || !image) return
    dataStore.put('content', _content.id, _content)
    i.value.contentId = _content.id
    i.value.imageId = image.id
    content.value = _content
  } catch (e) {}
}

const canCut = computed(() => {
  if (i.value.imgType === 'URL') {
    return i.value.url || i.value.thumbnailUrl
  } else if (i.value.imgType == 'UPLOAD') {
    return i.value.contentId && i.value.imageId
  } else if (i.value.imgType == 'ITEM') {
    return (
      item.value && (item.value.common.thumbnailUrl || item.value.common.iiifUrl)
    )
  } else if (i.value.imgType == 'IIIF') {
    return i.value.infoJsonUrl
  }
  return false
})

const areaSelectModal = ref<InstanceType<typeof AreaSelectModal>>()
const cutImage = async () => {
  let src = null
  let rate = 1.0
  if (i.value.imgType == 'UPLOAD') {
    src = iiifImageUrlFromContent(i.value.contentId, i.value.imageId)
  } else if (i.value.infoJsonUrl) {
    let infoJson: IIIFInfo = await getInfoJson(i.value.infoJsonUrl)
    if (infoJson.width > infoJson.height && infoJson.width > 600) {
      src = iiifImageUrlFromInfo(i.value.infoJsonUrl, null, { w: 600 })
      rate = 600 / infoJson.width
    } else if (infoJson.height > 400) {
      src = iiifImageUrlFromInfo(i.value.infoJsonUrl, null, { h: 400 })
      rate = 400 / infoJson.height
    } else {
      src = iiifImageUrlFromInfo(i.value.infoJsonUrl)
    }
  } else if (i.value.url) {
    src = i.value.url
  } else if (i.value.thumbnailUrl) {
    src = i.value.thumbnailUrl
  }
  let rect = i.value.w
    ? {
        x: i.value.x * rate,
        y: i.value.y * rate,
        w: i.value.w * rate,
        h: i.value.h * rate,
      }
    : {}

  try {
    const r = await areaSelectModal.value.openAwait({
      src: src,
      rect: rect,
      ruleField: _ruleField.value
    })
    if (!r) return
    i.value.x = r.x / rate
    i.value.y = r.y / rate
    i.value.w = r.w / rate
    i.value.h = r.h / rate
  } catch (cancel) {}
}
</script>

<style lang="scss" scoped>
@use '@/assets/styles/scss/vue' as *;

.jps-image-select-modal {
  background-color: $jps-gray-50;

  @include box-shadow;
  .jps-modal-content {
    height: 100%;
    width: 100%;
    display: flex;
  }

  .image-select-modal-body {
    flex-grow: 1;
  }

  .button-margin {
    margin-bottom: 0.25rem;
  }
  .trans {
    overflow: hidden;
    transform: translate(100px, 100px);
    /* width: 200px; */
    height: 150px;
  }
  .jps-validation-form {
    margin-bottom: 0.75rem;
  }

  .upload {
    .content-panel {
      margin-top: 1em;
      margin-bottom: 1em;
    }
  }

  .image-select-modal-select {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;

    .image-select-modal-select-button {
      width: fit-content;
    }
  }

  .jps-table {
    .jps-button {
      width: 100%;
    }
  }

  .jps-tab {
    flex-grow: 1;
  }

  .jps-preview {
    margin-left: 1rem;
    background: $white;
    max-width: 320px;
    overflow-y: scroll;
    box-sizing: border-box;
    padding: 1rem;
    border-radius: $global-radius;
    border: 1px solid $jps-gray-100;

    p,
    dt,
    dd {
      color: $jps-gray-600;
      line-height: 1rem;
    }
  }

  .tab-content {
    padding: 1rem;
  }

  @include is-mobile() {
    flex-direction: column;
    .tab-content {
      padding: 1rem 0;
    }
  }

  dl.jps-meta {
    text-align: left;
    dt {
      font-size: 0.75rem;
    }
    dd {
      padding-left: 0rem;
      padding-top: 0.25rem;
      font-size: $size-7;
    }
  }
}
</style>
